import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as tcRenewalAction from 'features/tc-renewal/duck';
import './TCRenewalGuide.scss';

class TCRenewalGuide extends Component {
  constructor(props) {
    super(props);
    const { testCenterCycle } = props;
    this.state = {
      isPdfClicked: false,
      cycleName: testCenterCycle?.cycle?.name || '',
    };
  }

  componentDidMount() {
    this.props.disableContinueBtn?.(true);
    if (this.props.tcCycleId) {
      this.fetchCycleData(this.props.tcCycleId);
    }
  }

  componentDidUpdate(prevProps) {
    const { testCenterCycle, tcCycleId } = this.props;

    if (prevProps.testCenterCycle !== testCenterCycle) {
      this.setState({ cycleName: testCenterCycle?.cycle?.name || '' });
    }

    if (prevProps.tcCycleId !== tcCycleId && tcCycleId) {
      this.fetchCycleData(tcCycleId);
    }
  }

  fetchCycleData = (tcCycleId) => {
    this.props.actions.getTcCycle(tcCycleId).catch((error) => {});
  };

  handlePdfClick = () => {
    this.setState({ isPdfClicked: true }, () => {
      this.props.disableContinueBtn?.(false);
    });
  };

  handleContinue = () => {
    return this.state.isPdfClicked;
  };

  render() {
    return (
      <div>
        <h4>{`${this.props.t('testCenter.renewalLabel')} ${this.state.cycleName}`}</h4>
        <div className="renewal-text-message">{this.props.t('testCenter.renewalTextMessage')}</div>
        <div className="renewal-guide-pdf">
          <a
            href="/src/assets/training/Test Center Capacity Renewal Guide.pdf"
            target="_blank"
            rel="noopener noreferrer"
            onClick={this.handlePdfClick}>
            {this.props.t('testCenter.renewalPdfText')}
          </a>
        </div>
      </div>
    );
  }
}

TCRenewalGuide.propTypes = {
  t: PropTypes.func.isRequired,
  testCenterCycle: PropTypes.shape({
    cycle: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  tcCycleId: PropTypes.number,
  disableContinueBtn: PropTypes.func,
  actions: PropTypes.shape({
    getTcCycle: PropTypes.func,
  }),
};

function mapStateToProps(state) {
  return {
    testCenterCycle: state.tcRenewal.tcCycle,
    tcCycleId: state.tcRenewal.tcCycleId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...tcRenewalAction,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(withTranslation(null, { withRef: true })(TCRenewalGuide));
